"use client";

import { useEffect } from "react";
import { trackClientPageView } from "/utils/analytics-client";
import { usePathname } from "next/navigation";
import { useAppContext } from "/context/app-context";

const PageViewTracker = () => {
  let userID = "";
  let userClass = "";
  let anonymousID = "";
  let countryCode = "";

  try {
    const context = useAppContext();
    userID = context.userID;
    userClass = context.userClass;
    anonymousID = context.anonymousID;
    countryCode = context.countryCode;
  } catch (error) {
    console.warn("PageViewTracker: AppContext not available, using defaults");
  }

  const pathname = usePathname();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        // Get browser headers (since `headers()` doesn't work in Client Components)
        const url = window.location.href;
        const referrer = document.referrer;
        const userAgent = navigator.userAgent;

        await trackClientPageView({
          userId: userID,
          userClass,
          anonymousId: anonymousID,
          url,
          path: pathname,
          title: document.title,
          referrer,
          userAgent,
          countryCode,
        });
      } catch (error) {
        console.warn("Page view tracking failed or timed out:", error);
        // Don't throw error - fail silently to prevent blocking page
      }
    };

    // Don't block the component render - run tracking async
    trackPageView();
  }, [pathname, userID, userClass, anonymousID, countryCode]);

  return null;
};

export default PageViewTracker;
